import { Button, DatePicker, Table , Row , Col , Form, message} from "antd";
import React, { useEffect, useState , useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { TransactonsFormPage } from "../components/transaction-form/transaction-form.component";
import { agentsSelector } from "../selector/agents.selector";
import '../styles/agent-transactions.style.scss';
import { isValid, isValidArray, isValidArrayWithValues } from "../utils/utilities";
import { getAgents ,getAgentsTransactions , updateAgentTransaction} from "../actions/agents.actions";
import { postCall } from "../utils/network.util";
import { GET_AGENT_BALANCE_URL } from "../utils/api-url";
import { isRechargeAgent } from "../components/upi-booking/upi-recharge.component";
import moment from 'moment';
import { getAPIDateFormat, getUIDateFormat } from "../utils/date.utils";
import { useLocation } from "react-router-dom";
import { AGENT_TRANSACTION_COMPLETED, AGENT_TRANSACTION_FAILED } from "../utils/constant";
import { loadingAction } from './../actions/loading-actions';
import { AgentTransactionEdit } from './../components/agent-transaction-edit/agent-transaction-edit.component';
import { getRangeOptions } from './reports/reports.module';
import { PrinterOutlined, DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

const { RangePicker } = DatePicker;


const DrawLine =()=>{

    return(
        <div className="agents-transactions-underline">

        </div>
    )
}

const Title = () =>{
        return (
            <div className="title-agent-transactions">
                <h3>
                    Agents Transactions
                </h3>
                <DrawLine />
            </div>
        )
}

export const AgentTransactonsPage = (props) => {

    const agents = useSelector(agentsSelector);
    const [ showTransactionForm , setShowTransactionForm] = useState(false);
    const [ agentTransactions , setAgentTransactions] = useState([]);
    const [ filteredTransactions , setFilteredTransactions] = useState([]);
    const [ dateRange , setDateRange] = useState({ startDate: null, endDate: null });
    const [ isLoggedInAgentMaster, setIsLoggedInAgentMaster] = useState(false);
    const [ displayingAgents, setDisplayingAgents] = useState ([]);
    const [ allowedAgentNames, setAllowedAgentNames] = useState([]);

    useEffect(() => {
        if (isValidArrayWithValues(agents)) {
            let tempMasterAgents = [];
            let subAgents = [];
            let loggedInAgent = global.agentId;
            agents.map((agent) => {
                if (!isValid(agent.master_agent_id)) {
                    tempMasterAgents.push(agent);
                }
                else {
                    if (loggedInAgent == agent.master_agent_id) {
                        setIsLoggedInAgentMaster(true);
                        subAgents.push(agent);
                    }
                }
            })
            let tempdisplayingAgents = isValidArrayWithValues(subAgents)?subAgents: tempMasterAgents;
            setDisplayingAgents(tempdisplayingAgents);
            setAllowedAgentNames(new Set(tempdisplayingAgents.map((agent) => agent.name)))
        }
    }, [agents])

    // Prepaid "agent" of a UPI-enabled operator: sees only their own transactions + wallet balance.
    const rechargeAgent = isRechargeAgent();
    const ownAgent = isValidArray(agents) ? agents.find((a) => a.id == global.agentId) : null;
    const ownAgentName = isValid(ownAgent) ? ownAgent.name : global.userName;
    const [balance, setBalance] = useState(global.amountLimit);

    const visibleAgentTransactions = !isValidArray(agentTransactions)
        ? []
        : rechargeAgent
            ? agentTransactions.filter((txn) => txn.agent_id == global.agentId || txn.agent_name === ownAgentName)
            : agentTransactions.filter((txn) => allowedAgentNames.has(txn.agent_name));

    const refreshBalance = () => {
        postCall(GET_AGENT_BALANCE_URL, { agentId: global.agentId })
            .then((res) => {
                if (res && res.status === 'SUCCESS' && isValid(res.payload) && res.payload.Status === 'SUCCESS' && isValid(res.payload.Payload)) {
                    setBalance(res.payload.Payload.amountLimit);
                }
            })
            .catch(() => {});
    };

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const searchRef = useRef(null);

    let today = getUIDateFormat(moment().utcOffset("+05:30"),'-');

    // Get unique agent names for filters
    const getAgentFilters = () => {
        const uniqueAgents = [...new Set(visibleAgentTransactions.map(item => item.agent_name).filter(Boolean))];
        return uniqueAgents.map(name => ({ text: name, value: name }));
    };

    const columns =[
        {
            title:'Sl.no',
            key:'index',
            render : (text, record, index) => index+1
        },
        {
            title:"Date",
            key:'date',
            dataIndex:'date',
            render:(text,row) =>{
                if(isValid(text)){
                    return (getUIDateFormat(text,'-'));
                }else{
                    return null;
                }
               
            }
        },
        {
            title:"Agent Name",
            key:'agent_name',
            dataIndex:'agent_name',
            filters: getAgentFilters(),
            onFilter: (value, record) => record.agent_name === value,
            filterSearch: true
        },
        {
            title:"Description",
            key:'description',
            dataIndex:'description'
        },
        {
            title:"Amount",
            key:'amount',
            dataIndex:'amount',
            render:(text,row) =>{
                // Recharge / self prepaid agents view their own wallet history read-only - no amount edit.
                if(!rechargeAgent && today === getUIDateFormat(row.date,'-')){
                    return (
                        <AgentTransactionEdit
                            agentTransactionId={row.id}
                            amount={text}
                            onCallBack={(agentTransactionId,amount)=>{
                                agentTransactions.forEach((element)=>{
                                    if(element.id===agentTransactionId){
                                        element.amount = amount;
                                    }
                                })
                                setAgentTransactions([...agentTransactions]);
                            }}
                        />
                    )
                }else{
                    return text;
                }
            }
        },
        {
            title:"Status",
            key:'status',
            dataIndex:'status',
            render:(text,row) =>{
                if(text === "Pending"){
                    return (
                        <div>
                            <Row>
                                {text}    
                            </Row>   
                            <Row gutter={[16,16]}>
                                <Col>
                                    <Button 
                                    size={"small"} 
                                    className="small-button" 
                                    onClick={()=>{
                                        updateTransaction(row.id,AGENT_TRANSACTION_FAILED);
                                    }}>Failed</Button>
                                </Col>
                                <Col>
                                    <Button 
                                    size={"small"} 
                                    className="small-button"
                                    onClick={()=>{
                                        updateTransaction(row.id,AGENT_TRANSACTION_COMPLETED);
                                    }}
                                    >Complete</Button>
                                </Col>
                            </Row>
                        </div>);
                }else{
                    return text;
                }
               
            }
        },
        {
            title:"Payment Type",
            key:'payment_type',
            dataIndex:'payment_type'
        },
        {
            title:"Ref ID",
            key:'ref_id',
            dataIndex:'ref_id'
        },
        {
            title:"Updated By",
            key:'updated_by',
            dataIndex:'updated_by'
        }
    ];

    const location = useLocation()
    let agentId = null;
    if(isValid(location.state)){
        agentId = location.state.agentId;
    }


    const setLoading =(bool)=>{
        dispatch(loadingAction(bool));
    }
    
    const getAgentsDispatch = () =>{
        dispatch(getAgents(true,true));
    }

    const getAgentsTransactionsDispatch = (startDate,endDate) =>{
        dispatch(getAgentsTransactions(startDate,endDate,(data)=>{
            setAgentTransactions(data);
        },()=>{}))
    }

    useEffect(()=>{
        if(!isValidArray(agents)||agents.length==0){
            getAgentsDispatch();
        }
        if(rechargeAgent){
            refreshBalance();
        }
    },[]);

    const handleTransactionComplete = () => {
        if(rechargeAgent){
            refreshBalance();
        }
        getAgentsTransactionsDispatch(dateRange.startDate, dateRange.endDate);
    };

    const onFinish=(values)=>{
        let {
            dateRange: dateRangeValue
        } = values;
        let startDate = getAPIDateFormat(dateRangeValue[0]);
        let endDate = getAPIDateFormat(dateRangeValue[1]);
        setDateRange({ 
            startDate: moment(dateRangeValue[0]).format('DD-MM-YYYY'), 
            endDate: moment(dateRangeValue[1]).format('DD-MM-YYYY')
        });
        getAgentsTransactionsDispatch(startDate,endDate);
    }

    const updateTransaction=(agentTransactionId,status)=>{
        setLoading(true);
        updateAgentTransaction(agentTransactionId,status,null,()=>{
            message.success("Transaction updated successfully");
            searchRef.current.click();            
            setLoading(false);
        },()=>{
            setLoading(false);
        })
    }

    const handleExport = () => {
        // Use filtered data if available, otherwise use all data
        const dataToExport = filteredTransactions.length > 0 ? filteredTransactions : visibleAgentTransactions;
        
        // Create workbook
        const wb = XLSX.utils.book_new();
        
        // Create worksheet data with header information
        const worksheetData = [];
        
        // Add title
        worksheetData.push([`${global.operatorName} - Agent Transactions`]);
        
        // Add date range if available
        if (dateRange.startDate && dateRange.endDate) {
            worksheetData.push([`Date Range: ${dateRange.startDate} to ${dateRange.endDate}`, '']);
        } else {
            worksheetData.push([`Date: ${moment().format('DD-MM-YYYY')}`]);
        }
        
        // Add empty row for spacing
        worksheetData.push([]);
        
        // Add table headers
        worksheetData.push(['Sl.no', 'Date', 'Agent Name', 'Description', 'Amount', 'Status', 'Payment Type', 'Ref ID', 'Updated By']);
        
        // Add data rows
        dataToExport.forEach((row, index) => {
            worksheetData.push([
                index + 1,
                isValid(row.date) ? moment(row.date).format('DD-MM-YYYY') : '',
                row.agent_name || '',
                row.description || '',
                row.amount || '',
                row.status || '',
                row.payment_type || '',
                row.ref_id || '',
                row.updated_by || ''
            ]);
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(worksheetData);

        // Set column widths
        ws['!cols'] = [
            { wch: 8 },  // Sl.no
            { wch: 12 }, // Date
            { wch: 20 }, // Agent Name
            { wch: 30 }, // Description
            { wch: 12 }, // Amount
            { wch: 12 }, // Status
            { wch: 15 }, // Payment Type
            { wch: 15 }, // Ref ID
            { wch: 20 }  // Updated By
        ];

        // Merge cells for title (A1:I1)
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }, // Title row
            { s: { r: 1, c: 0 }, e: { r: 1, c: 8 } }  // Date range row
        ];

        // Style the title and date range cells (optional, basic styling)
        if (ws['A1']) {
            ws['A1'].s = {
                font: { bold: true, sz: 14 },
                alignment: { horizontal: 'center', vertical: 'center' }
            };
        }
        if (ws['A2']) {
            ws['A2'].s = {
                font: { sz: 11 },
                alignment: { horizontal: 'center', vertical: 'center' }
            };
        }

        XLSX.utils.book_append_sheet(wb, ws, 'Agent Transactions');

        // Generate filename with date range
        const dateRangeStr = dateRange.startDate && dateRange.endDate 
            ? `_${dateRange.startDate.replace(/-/g, '')}_to_${dateRange.endDate.replace(/-/g, '')}` 
            : `_${moment().format('DDMMYYYY')}`;
        const filename = `agent_transactions${dateRangeStr}.xlsx`;

        // Download file
        XLSX.writeFile(wb, filename);
        message.success('Transactions exported successfully');
    };

    const handlePrint = () => {
        // Use filtered data if available, otherwise use all data
        const dataToPrint = filteredTransactions.length > 0 ? filteredTransactions : visibleAgentTransactions;
        
        // Create printable HTML
        const printWindow = window.open('', '', 'height=600,width=800');
        const dateRangeText = dateRange.startDate && dateRange.endDate 
            ? `Date Range: ${dateRange.startDate} to ${dateRange.endDate}` 
            : '';
        const tableHTML = `
            <html>
                <head>
                    <title>${global.operatorName} - Agent Transactions</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        h2 { text-align: center; margin-bottom: 10px; }
                        .date-range { text-align: center; margin-bottom: 20px; font-size: 14px; color: #666; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 12px; }
                        th { background-color: #f2f2f2; font-weight: bold; }
                        tr:nth-child(even) { background-color: #f9f9f9; }
                        @media print {
                            body { margin: 0; }
                            button { display: none; }
                        }
                    </style>
                </head>
                <body>
                    <h2>${global.operatorName} - Agent Transactions</h2>
                    ${dateRangeText ? `<div class="date-range">${dateRangeText}</div>` : ''}
                    <table>
                        <thead>
                            <tr>
                                <th>Sl.no</th>
                                <th>Date</th>
                                <th>Agent Name</th>
                                <th>Description</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Payment Type</th>
                                <th>Ref ID</th>
                                <th>Updated By</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${dataToPrint.map((row, index) => `
                                <tr>
                                    <td>${index + 1}</td>
                                    <td>${isValid(row.date) ? moment(row.date).format('DD-MM-YYYY') : ''}</td>
                                    <td>${row.agent_name || ''}</td>
                                    <td>${row.description || ''}</td>
                                    <td>${row.amount || ''}</td>
                                    <td>${row.status || ''}</td>
                                    <td>${row.payment_type || ''}</td>
                                    <td>${row.ref_id || ''}</td>
                                    <td>${row.updated_by || ''}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `;
        printWindow.document.write(tableHTML);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 250);
    };

    // Handle table changes (filters, sorters, etc.)
    const handleTableChange = (pagination, filters, sorter, extra) => {
        // Update filtered transactions when filter changes
        if (extra.action === 'filter') {
            setFilteredTransactions(extra.currentDataSource);
        }
    };

    return (
        <div className="agents-page-root">
            <div className="agents-page-inner-div">
                <Title />
                {rechargeAgent &&
                    <div className="agent-wallet-balance" style={{margin:'8px 0', fontSize:16}}>
                        <strong>Current Balance : </strong>{isValid(balance) ? balance : global.amountLimit}
                    </div>
                }
                <div>
                    <TransactonsFormPage
                        setShowTransactionForm={setShowTransactionForm}
                        showTransactionForm={showTransactionForm}
                        agents={displayingAgents}
                        selectedAgentId={rechargeAgent ? global.agentId : agentId}
                        onCompleteTransaction={handleTransactionComplete}
                    />
                </div>
                <div className="marginBottom">
                    <Form
                        form={form}
                        initialValues={{ dateRange :[moment().utcOffset("+05:30"),moment().utcOffset("+05:30")]}}
                        className = "agent-form"
                        onFinish={onFinish}
                    >
                        <Row gutter={[16,16]}>
                            <Col>
                                <Form.Item
                                    label="Date"
                                    rules={[{ required: true, message: 'Please input date' }]}
                                    name="dateRange"
                                    >
                                    <RangePicker ranges={getRangeOptions(31)} renderExtraFooter={() => null} />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Button htmlType="submit" ref={searchRef}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
                {isValidArray(visibleAgentTransactions) && visibleAgentTransactions.length > 0 && (
                    <div className="marginBottom">
                        <Row gutter={[16, 16]}>
                            <Col>
                                <Button
                                    type="primary"
                                    icon={<DownloadOutlined />}
                                    onClick={handleExport}
                                >
                                    Export
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    type="default"
                                    icon={<PrinterOutlined />}
                                    onClick={handlePrint}
                                >
                                    Print
                                </Button>
                            </Col>
                        </Row>
                    </div>
                )}
                <div>
                    <Table
                        columns={columns}
                        dataSource={visibleAgentTransactions}
                        pagination={false}
                        onChange={handleTableChange}
                    />
                </div>
            </div>
        </div>
    );
}